import { ActivatedRoute, Router } from '@angular/router';
import { delay, of, takeUntil } from 'rxjs';
import { inject } from '@angular/core';

import { Loader, UnsubscriberClass } from '../../classes';
import { AppConstants } from '../../config/constants.config';

const SIGNIN_TIMEOUT = 5 * AppConstants.SECOND

export abstract class LoginAbstractPageComponent extends UnsubscriberClass {

	protected activatedRoute = inject(ActivatedRoute)
	protected router = inject(Router)

	formLoader = new Loader(true);
	redirectAlreadyDone: boolean;

	/**
	 * We are sometimes redirect here while the auth is checked.
	 * Wait a few seconds before triggering a new signin process.
	 */
	notLoggedInFallback$ = of(null).pipe(
		delay(SIGNIN_TIMEOUT),
		takeUntil(this.destroySubscriptions$)
	)
}
